// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/users/UserStatusBadge.jsx

import React from "react";
import { StatusChip } from "../../../design-system/components";

function labelFor(value) {
  return String(value || "unknown")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function toneFor(status) {
  if (["active", "accepted", "completed"].includes(status)) return "success";
  if (["pending", "invited", "review"].includes(status)) return "warning";
  if (["suspended", "removed", "cancelled", "expired"].includes(status)) return "danger";
  return "neutral";
}

export default function UserStatusBadge({ status }) {
  const normalized = String(status || "unknown").toLowerCase();

  return (
    <StatusChip
      tone={toneFor(normalized)}
      className={`enterprise-admin-status enterprise-admin-status-${normalized}`}
    >
      {labelFor(normalized)}
    </StatusChip>
  );
}
